/**
 * GENERATED by `npm run versions` (generate-theme-versions.js) - do not edit by hand.
 *
 * The version each theme listing carries on each store, read from the published
 * artifact itself (JetBrains plugin.xml, the VS Code package.json, the Chrome
 * and Firefox manifests, the store catalogue). The theme page prints it under the platform
 * name. STORE_PLATFORM_VERSIONS is only the fallback for a listing sold here:
 * the live catalogue wins as soon as the store API answers.
 */

/** version per theme key, per platform display name */
export const PLATFORM_VERSIONS: { [ themeKey: string ]: { [ platform: string ]: string } } = {
  'aurora-borealis': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.30',
    'VS Code': '2026.1.26',
    'Open VSX': '2026.1.26',
    'Chrome': '2026.1.26',
    'Firefox': '2026.1.28'
  },
  'autumn': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.30',
    'VS Code': '2026.1.26',
    'Open VSX': '2026.1.26',
    'Chrome': '2026.1.26',
    'Firefox': '2026.1.28'
  },
  'bioluminescence': {
    'JetBrains': '2026.1.0',
    'Firefox': '2026.1.0'
  },
  'etna': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.7',
    'Firefox': '2026.1.6'
  },
  'everest': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.29',
    'VS Code': '2026.1.25',
    'Open VSX': '2026.1.25',
    'Chrome': '2026.1.25',
    'Firefox': '2026.1.27'
  },
  'fuji': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.8',
    'Firefox': '2026.1.7'
  },
  'ocean': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.7',
    'VS Code': '2026.1.3',
    'Open VSX': '2026.1.3',
    'Firefox': '2026.1.6'
  },
  'reynisfjara': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.7',
    'Firefox': '2026.1.6'
  },
  'roraima': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.32',
    'VS Code': '2026.1.28',
    'Open VSX': '2026.1.28',
    'Chrome': '2026.1.28',
    'Firefox': '2026.1.30'
  },
  'sakura': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.30',
    'VS Code': '2026.1.26',
    'Open VSX': '2026.1.26',
    'Chrome': '2026.1.26',
    'Firefox': '2026.1.28'
  },
  'salda': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.7',
    'Firefox': '2026.1.6'
  },
  'sequoia': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.30',
    'VS Code': '2026.1.26',
    'Open VSX': '2026.1.26',
    'Chrome': '2026.1.26',
    'Firefox': '2026.1.28'
  },
  'spring': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.7',
    'Firefox': '2026.1.6'
  },
  'dublin': {
    'JetBrains': '2026.1.5',
    'Firefox': '2026.1.4'
  },
  'istanbul': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.26',
    'VS Code': '2026.1.22',
    'Open VSX': '2026.1.22',
    'Chrome': '2026.1.22',
    'Firefox': '2026.1.24'
  },
  'london': {
    'JetBrains': '2026.1.7',
    'Firefox': '2026.1.6'
  },
  'madrid': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.7',
    'Firefox': '2026.1.6'
  },
  'miami': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.28',
    'VS Code': '2026.1.24',
    'Open VSX': '2026.1.24',
    'Chrome': '2026.1.24',
    'Firefox': '2026.1.26'
  },
  'paris': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.25',
    'VS Code': '2026.1.21',
    'Open VSX': '2026.1.21',
    'Chrome': '2026.1.21',
    'Firefox': '2026.1.23'
  },
  'prague': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.7',
    'Firefox': '2026.1.6'
  },
  'rio-de-janeiro': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.26',
    'VS Code': '2026.1.22',
    'Open VSX': '2026.1.22',
    'Chrome': '2026.1.22',
    'Firefox': '2026.1.24'
  },
  'sydney': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.7',
    'Firefox': '2026.1.6'
  },
  'tallinn': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.26',
    'VS Code': '2026.1.22',
    'Open VSX': '2026.1.22',
    'Chrome': '2026.1.22',
    'Firefox': '2026.1.24'
  },
  'tokyo': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.25',
    'VS Code': '2026.1.21',
    'Open VSX': '2026.1.21',
    'Chrome': '2026.1.21',
    'Firefox': '2026.1.23'
  },
  'vienna': {
    'Line': '2026.1.0',
    'JetBrains': '2026.1.7',
    'Firefox': '2026.1.6'
  },
  'all-in-one': {
    'JetBrains': '2026.1.27',
    'Chrome': '2026.1.28'
  }
};

/** version per theme key, per palette platform key (figma / coreldraw / macos) */
export const PALETTE_PLATFORM_VERSIONS: { [ themeKey: string ]: { [ platform: string ]: string } } = {
  'aurora-borealis': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'autumn': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'bioluminescence': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'etna': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'everest': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'fuji': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'ocean': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'reynisfjara': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'roraima': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'sakura': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'salda': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'sequoia': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'spring': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'dublin': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'istanbul': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'london': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'madrid': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'miami': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'paris': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'prague': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'rio-de-janeiro': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'sydney': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'tallinn': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'tokyo': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  },
  'vienna': {
    'figma': '2026.1.0',
    'coreldraw': '2026.1.0',
    'macos': '2026.1.0'
  }
};

/** version per store sku, the fallback until the live catalogue answers */
export const STORE_PLATFORM_VERSIONS: { [ sku: string ]: string } = {
  'ai-token-meter/macos': '1.0.0',
  'aurora-borealis/claude-code': '2026.1.29',
  'aurora-borealis/codex': '2026.1.29',
  'aurora-borealis/coreldraw-palette': '2026.1.0',
  'aurora-borealis/figma-palette': '2026.1.0',
  'aurora-borealis/ghostty': '2026.1.29',
  'aurora-borealis/iterm2': '2026.1.29',
  'aurora-borealis/macos-palette': '2026.1.0',
  'aurora-borealis/macos-terminal': '2026.1.29',
  'aurora-borealis/opencode': '2026.1.29',
  'aurora-borealis/rhino': '2026.1.26',
  'aurora-borealis/slack': '2026.1.26',
  'aurora-borealis/sublime-text': '2026.1.26',
  'aurora-borealis/xcode': '2026.1.26',
  'aurora-borealis/zed': '2026.1.26',
  'autumn/claude-code': '2026.1.29',
  'autumn/codex': '2026.1.29',
  'autumn/coreldraw-palette': '2026.1.0',
  'autumn/figma-palette': '2026.1.0',
  'autumn/ghostty': '2026.1.29',
  'autumn/iterm2': '2026.1.29',
  'autumn/macos-palette': '2026.1.0',
  'autumn/macos-terminal': '2026.1.29',
  'autumn/opencode': '2026.1.29',
  'autumn/rhino': '2026.1.26',
  'autumn/slack': '2026.1.26',
  'autumn/sublime-text': '2026.1.26',
  'autumn/xcode': '2026.1.26',
  'autumn/zed': '2026.1.26',
  'bioluminescence/claude-code': '2026.1.0',
  'bioluminescence/codex': '2026.1.0',
  'bioluminescence/firefox': '2026.1.0',
  'bioluminescence/ghostty': '2026.1.0',
  'bioluminescence/iterm2': '2026.1.0',
  'bioluminescence/macos-terminal': '2026.1.0',
  'bioluminescence/opencode': '2026.1.0',
  'bioluminescence/rhino': '2026.1.0',
  'bioluminescence/slack': '2026.1.0',
  'bioluminescence/sublime-text': '2026.1.0',
  'bioluminescence/xcode': '2026.1.0',
  'bioluminescence/zed': '2026.1.0',
  'color-picker/macos': '1.0.0',
  'dublin/claude-code': '2026.1.4',
  'dublin/codex': '2026.1.4',
  'dublin/firefox': '2026.1.4',
  'dublin/ghostty': '2026.1.4',
  'dublin/iterm2': '2026.1.4',
  'dublin/macos-terminal': '2026.1.4',
  'dublin/opencode': '2026.1.4',
  'dublin/rhino': '2026.1.1',
  'dublin/slack': '2026.1.1',
  'dublin/sublime-text': '2026.1.1',
  'dublin/xcode': '2026.1.1',
  'dublin/zed': '2026.1.1',
  'etna/claude-code': '2026.1.6',
  'etna/codex': '2026.1.6',
  'etna/coreldraw-palette': '2026.1.0',
  'etna/figma-palette': '2026.1.0',
  'etna/firefox': '2026.1.6',
  'etna/ghostty': '2026.1.6',
  'etna/iterm2': '2026.1.6',
  'etna/macos-palette': '2026.1.0',
  'etna/macos-terminal': '2026.1.6',
  'etna/opencode': '2026.1.6',
  'etna/rhino': '2026.1.3',
  'etna/slack': '2026.1.3',
  'etna/sublime-text': '2026.1.3',
  'etna/xcode': '2026.1.3',
  'etna/zed': '2026.1.3',
  'everest/claude-code': '2026.1.28',
  'everest/codex': '2026.1.28',
  'everest/coreldraw-palette': '2026.1.0',
  'everest/figma-palette': '2026.1.0',
  'everest/ghostty': '2026.1.28',
  'everest/iterm2': '2026.1.28',
  'everest/macos-palette': '2026.1.0',
  'everest/macos-terminal': '2026.1.28',
  'everest/opencode': '2026.1.28',
  'everest/rhino': '2026.1.25',
  'everest/slack': '2026.1.25',
  'everest/sublime-text': '2026.1.25',
  'everest/xcode': '2026.1.25',
  'everest/zed': '2026.1.25',
  'fuji/claude-code': '2026.1.7',
  'fuji/codex': '2026.1.7',
  'fuji/firefox': '2026.1.7',
  'fuji/ghostty': '2026.1.7',
  'fuji/iterm2': '2026.1.7',
  'fuji/macos-terminal': '2026.1.7',
  'fuji/opencode': '2026.1.7',
  'fuji/rhino': '2026.1.4',
  'fuji/slack': '2026.1.4',
  'fuji/sublime-text': '2026.1.4',
  'fuji/xcode': '2026.1.4',
  'fuji/zed': '2026.1.4',
  'istanbul/claude-code': '2026.1.25',
  'istanbul/codex': '2026.1.25',
  'istanbul/coreldraw-palette': '2026.1.0',
  'istanbul/figma-palette': '2026.1.0',
  'istanbul/ghostty': '2026.1.25',
  'istanbul/iterm2': '2026.1.25',
  'istanbul/macos-palette': '2026.1.0',
  'istanbul/macos-terminal': '2026.1.25',
  'istanbul/opencode': '2026.1.25',
  'istanbul/rhino': '2026.1.22',
  'istanbul/slack': '2026.1.22',
  'istanbul/sublime-text': '2026.1.22',
  'istanbul/xcode': '2026.1.22',
  'istanbul/zed': '2026.1.22',
  'london/claude-code': '2026.1.6',
  'london/codex': '2026.1.6',
  'london/firefox': '2026.1.6',
  'london/ghostty': '2026.1.6',
  'london/iterm2': '2026.1.6',
  'london/macos-terminal': '2026.1.6',
  'london/opencode': '2026.1.6',
  'london/rhino': '2026.1.3',
  'london/slack': '2026.1.3',
  'london/sublime-text': '2026.1.3',
  'london/xcode': '2026.1.3',
  'london/zed': '2026.1.3',
  'madrid/claude-code': '2026.1.6',
  'madrid/codex': '2026.1.6',
  'madrid/coreldraw-palette': '2026.1.0',
  'madrid/figma-palette': '2026.1.0',
  'madrid/firefox': '2026.1.6',
  'madrid/ghostty': '2026.1.6',
  'madrid/iterm2': '2026.1.6',
  'madrid/macos-palette': '2026.1.0',
  'madrid/macos-terminal': '2026.1.6',
  'madrid/opencode': '2026.1.6',
  'madrid/rhino': '2026.1.3',
  'madrid/slack': '2026.1.3',
  'madrid/sublime-text': '2026.1.3',
  'madrid/xcode': '2026.1.3',
  'madrid/zed': '2026.1.3',
  'miami/claude-code': '2026.1.27',
  'miami/codex': '2026.1.27',
  'miami/coreldraw-palette': '2026.1.0',
  'miami/figma-palette': '2026.1.0',
  'miami/ghostty': '2026.1.27',
  'miami/iterm2': '2026.1.27',
  'miami/macos-palette': '2026.1.0',
  'miami/macos-terminal': '2026.1.27',
  'miami/opencode': '2026.1.27',
  'miami/rhino': '2026.1.24',
  'miami/slack': '2026.1.24',
  'miami/sublime-text': '2026.1.24',
  'miami/xcode': '2026.1.24',
  'miami/zed': '2026.1.24',
  'ocean/claude-code': '2026.1.6',
  'ocean/codex': '2026.1.6',
  'ocean/coreldraw-palette': '2026.1.0',
  'ocean/figma-palette': '2026.1.0',
  'ocean/firefox': '2026.1.6',
  'ocean/ghostty': '2026.1.6',
  'ocean/iterm2': '2026.1.6',
  'ocean/macos-palette': '2026.1.0',
  'ocean/macos-terminal': '2026.1.6',
  'ocean/opencode': '2026.1.6',
  'ocean/rhino': '2026.1.3',
  'ocean/slack': '2026.1.3',
  'ocean/sublime-text': '2026.1.3',
  'ocean/xcode': '2026.1.3',
  'ocean/zed': '2026.1.3',
  'paris/claude-code': '2026.1.24',
  'paris/codex': '2026.1.24',
  'paris/coreldraw-palette': '2026.1.0',
  'paris/figma-palette': '2026.1.0',
  'paris/ghostty': '2026.1.24',
  'paris/iterm2': '2026.1.24',
  'paris/macos-palette': '2026.1.0',
  'paris/macos-terminal': '2026.1.24',
  'paris/opencode': '2026.1.24',
  'paris/rhino': '2026.1.21',
  'paris/slack': '2026.1.21',
  'paris/sublime-text': '2026.1.21',
  'paris/xcode': '2026.1.21',
  'paris/zed': '2026.1.21',
  'prague/claude-code': '2026.1.6',
  'prague/codex': '2026.1.6',
  'prague/coreldraw-palette': '2026.1.0',
  'prague/figma-palette': '2026.1.0',
  'prague/firefox': '2026.1.6',
  'prague/ghostty': '2026.1.6',
  'prague/iterm2': '2026.1.6',
  'prague/macos-palette': '2026.1.0',
  'prague/macos-terminal': '2026.1.6',
  'prague/opencode': '2026.1.6',
  'prague/rhino': '2026.1.3',
  'prague/slack': '2026.1.3',
  'prague/sublime-text': '2026.1.3',
  'prague/xcode': '2026.1.3',
  'prague/zed': '2026.1.3',
  'reynisfjara/claude-code': '2026.1.6',
  'reynisfjara/codex': '2026.1.6',
  'reynisfjara/coreldraw-palette': '2026.1.0',
  'reynisfjara/figma-palette': '2026.1.0',
  'reynisfjara/firefox': '2026.1.6',
  'reynisfjara/ghostty': '2026.1.6',
  'reynisfjara/iterm2': '2026.1.6',
  'reynisfjara/macos-palette': '2026.1.0',
  'reynisfjara/macos-terminal': '2026.1.6',
  'reynisfjara/opencode': '2026.1.6',
  'reynisfjara/rhino': '2026.1.3',
  'reynisfjara/slack': '2026.1.3',
  'reynisfjara/sublime-text': '2026.1.3',
  'reynisfjara/xcode': '2026.1.3',
  'reynisfjara/zed': '2026.1.3',
  'rio-de-janeiro/claude-code': '2026.1.25',
  'rio-de-janeiro/codex': '2026.1.25',
  'rio-de-janeiro/coreldraw-palette': '2026.1.0',
  'rio-de-janeiro/figma-palette': '2026.1.0',
  'rio-de-janeiro/ghostty': '2026.1.25',
  'rio-de-janeiro/iterm2': '2026.1.25',
  'rio-de-janeiro/macos-palette': '2026.1.0',
  'rio-de-janeiro/macos-terminal': '2026.1.25',
  'rio-de-janeiro/opencode': '2026.1.25',
  'rio-de-janeiro/rhino': '2026.1.22',
  'rio-de-janeiro/slack': '2026.1.22',
  'rio-de-janeiro/sublime-text': '2026.1.22',
  'rio-de-janeiro/xcode': '2026.1.22',
  'rio-de-janeiro/zed': '2026.1.22',
  'roraima/claude-code': '2026.1.31',
  'roraima/codex': '2026.1.31',
  'roraima/coreldraw-palette': '2026.1.0',
  'roraima/figma-palette': '2026.1.0',
  'roraima/ghostty': '2026.1.31',
  'roraima/iterm2': '2026.1.31',
  'roraima/macos-palette': '2026.1.0',
  'roraima/macos-terminal': '2026.1.31',
  'roraima/opencode': '2026.1.31',
  'roraima/rhino': '2026.1.28',
  'roraima/slack': '2026.1.28',
  'roraima/sublime-text': '2026.1.28',
  'roraima/xcode': '2026.1.28',
  'roraima/zed': '2026.1.28',
  'sakura/claude-code': '2026.1.29',
  'sakura/codex': '2026.1.29',
  'sakura/coreldraw-palette': '2026.1.0',
  'sakura/figma-palette': '2026.1.0',
  'sakura/ghostty': '2026.1.29',
  'sakura/iterm2': '2026.1.29',
  'sakura/macos-palette': '2026.1.0',
  'sakura/macos-terminal': '2026.1.29',
  'sakura/opencode': '2026.1.29',
  'sakura/rhino': '2026.1.26',
  'sakura/slack': '2026.1.26',
  'sakura/sublime-text': '2026.1.26',
  'sakura/xcode': '2026.1.26',
  'sakura/zed': '2026.1.26',
  'salda/claude-code': '2026.1.6',
  'salda/codex': '2026.1.6',
  'salda/coreldraw-palette': '2026.1.0',
  'salda/figma-palette': '2026.1.0',
  'salda/firefox': '2026.1.6',
  'salda/ghostty': '2026.1.6',
  'salda/iterm2': '2026.1.6',
  'salda/macos-palette': '2026.1.0',
  'salda/macos-terminal': '2026.1.6',
  'salda/opencode': '2026.1.6',
  'salda/rhino': '2026.1.3',
  'salda/slack': '2026.1.3',
  'salda/sublime-text': '2026.1.3',
  'salda/xcode': '2026.1.3',
  'salda/zed': '2026.1.3',
  'sequoia/claude-code': '2026.1.29',
  'sequoia/codex': '2026.1.29',
  'sequoia/coreldraw-palette': '2026.1.0',
  'sequoia/figma-palette': '2026.1.0',
  'sequoia/ghostty': '2026.1.29',
  'sequoia/iterm2': '2026.1.29',
  'sequoia/macos-palette': '2026.1.0',
  'sequoia/macos-terminal': '2026.1.29',
  'sequoia/opencode': '2026.1.29',
  'sequoia/rhino': '2026.1.26',
  'sequoia/slack': '2026.1.26',
  'sequoia/sublime-text': '2026.1.26',
  'sequoia/xcode': '2026.1.26',
  'sequoia/zed': '2026.1.26',
  'spring/claude-code': '2026.1.6',
  'spring/codex': '2026.1.6',
  'spring/coreldraw-palette': '2026.1.0',
  'spring/figma-palette': '2026.1.0',
  'spring/firefox': '2026.1.6',
  'spring/ghostty': '2026.1.6',
  'spring/iterm2': '2026.1.6',
  'spring/macos-palette': '2026.1.0',
  'spring/macos-terminal': '2026.1.6',
  'spring/opencode': '2026.1.6',
  'spring/rhino': '2026.1.3',
  'spring/slack': '2026.1.3',
  'spring/sublime-text': '2026.1.3',
  'spring/xcode': '2026.1.3',
  'spring/zed': '2026.1.3',
  'sydney/claude-code': '2026.1.6',
  'sydney/codex': '2026.1.6',
  'sydney/coreldraw-palette': '2026.1.0',
  'sydney/figma-palette': '2026.1.0',
  'sydney/firefox': '2026.1.6',
  'sydney/ghostty': '2026.1.6',
  'sydney/iterm2': '2026.1.6',
  'sydney/macos-palette': '2026.1.0',
  'sydney/macos-terminal': '2026.1.6',
  'sydney/opencode': '2026.1.6',
  'sydney/rhino': '2026.1.3',
  'sydney/slack': '2026.1.3',
  'sydney/sublime-text': '2026.1.3',
  'sydney/xcode': '2026.1.3',
  'sydney/zed': '2026.1.3',
  'tallinn/claude-code': '2026.1.25',
  'tallinn/codex': '2026.1.25',
  'tallinn/coreldraw-palette': '2026.1.0',
  'tallinn/figma-palette': '2026.1.0',
  'tallinn/ghostty': '2026.1.25',
  'tallinn/iterm2': '2026.1.25',
  'tallinn/macos-palette': '2026.1.0',
  'tallinn/macos-terminal': '2026.1.25',
  'tallinn/opencode': '2026.1.25',
  'tallinn/rhino': '2026.1.22',
  'tallinn/slack': '2026.1.22',
  'tallinn/sublime-text': '2026.1.22',
  'tallinn/xcode': '2026.1.22',
  'tallinn/zed': '2026.1.22',
  'tidy-desktop/macos': '1.0',
  'tokyo/claude-code': '2026.1.24',
  'tokyo/codex': '2026.1.24',
  'tokyo/coreldraw-palette': '2026.1.0',
  'tokyo/figma-palette': '2026.1.0',
  'tokyo/ghostty': '2026.1.24',
  'tokyo/iterm2': '2026.1.24',
  'tokyo/macos-palette': '2026.1.0',
  'tokyo/macos-terminal': '2026.1.24',
  'tokyo/opencode': '2026.1.24',
  'tokyo/rhino': '2026.1.21',
  'tokyo/slack': '2026.1.21',
  'tokyo/sublime-text': '2026.1.21',
  'tokyo/xcode': '2026.1.21',
  'tokyo/zed': '2026.1.21',
  'vienna/claude-code': '2026.1.6',
  'vienna/codex': '2026.1.6',
  'vienna/coreldraw-palette': '2026.1.0',
  'vienna/figma-palette': '2026.1.0',
  'vienna/firefox': '2026.1.6',
  'vienna/ghostty': '2026.1.6',
  'vienna/iterm2': '2026.1.6',
  'vienna/macos-palette': '2026.1.0',
  'vienna/macos-terminal': '2026.1.6',
  'vienna/opencode': '2026.1.6',
  'vienna/rhino': '2026.1.3',
  'vienna/slack': '2026.1.3',
  'vienna/sublime-text': '2026.1.3',
  'vienna/xcode': '2026.1.3',
  'vienna/zed': '2026.1.3'
};
